import React, { useState } from "react";
import classNames from "classnames";

import { useIntl } from "react-intl";
import { currencyFormat } from "../../util/i18n.js";
import useEnsureVisible from "../../hooks/useEnsureVisible.js";

import Template from "./ItemCard.jsx";
import { post } from "../../util/fetch.js";

export default function ItemCardController(props) {
  const {
    allow_ordering_before_suggestions_at,
    position,
    isListCard,
    id,
    index,
    isAtEndOfRow = false,
    isDesktop,
    latestRow,
    editable,
    isItemOpen,
    cardRef,
    hide_sale_price_in_cart,
    display_inactive,
    onFavouriteAddRemove,
    ownerlessShop,
    name,
    categoryId,
    sale_price_pro_bu,
    sale_price_pro_sale_unit,
    setLatestRow = () => {},
    stk,
    sales_unit_display,
    sales_package_weight,
    subscriptionId,
    customToggleEditVisible,
    openedId,
    display_in_cart,
    listRef,
    isFavourite,
  } = props;
  const inactive =
    !editable ||
    display_inactive ||
    (!allow_ordering_before_suggestions_at && position === "catalog");

  const showQuantityControl = display_in_cart || position === "catalog";
  const gridStyle = computeGridStyle();
  // custom hooks that ensures the card is visible on screen when opened
  useEnsureVisible(isItemOpen, openedId, cardRef, listRef);
  const intl = useIntl();

  const soldOutText = intl.formatMessage({
    id: "soldOut",
  });

  const isEditableContainer = position === "cart" && hide_sale_price_in_cart;

  const extraPriceInfo = !isListCard
    ? `${stk} ${sales_unit_display} ${sales_package_weight}`
    : "";

  const price = `${
    currencyFormat(sale_price_pro_bu) !==
    currencyFormat(sale_price_pro_sale_unit)
      ? currencyFormat(sale_price_pro_sale_unit) + "€"
      : currencyFormat(sale_price_pro_bu) + "€"
  } ${extraPriceInfo}`;

  function computeGridStyle() {
    const newIndex = index + latestRow;
    const grid_row = Math.ceil(newIndex / 3);
    const desktopItemRow = Math.floor(index / 5) + 1;
    if (isItemOpen) {
      if (!isDesktop) {
        return { gridRow: latestRow > 1 ? undefined : grid_row };
      } else if (isAtEndOfRow) {
        return {
          gridArea: ` ${desktopItemRow} / 4 / ${desktopItemRow + 2} / 6`,
        };
      }
    }
    return {};
  }

  const getItemClasses = () => {
    if (isListCard)
      return classNames(`${position}-item list-item`, {
        "is-item-open": isItemOpen,
        "is-not-editable": inactive,
      });
    const baseClass = isItemOpen
      ? "catalog-item grid-opened"
      : `${position}-grid-item`;
    return classNames(baseClass, {
      "is-item-open": isItemOpen,
      "is-not-editable": inactive,
      "mobile-catalog-item": !isDesktop && isItemOpen,
      "inactive-background": inactive,
    });
  };

  const handleMainContentClick = (e) => {
    if (latestRow > 0 || !isListCard) {
      setLatestRow(latestRow - 1);
    }
    return customToggleEditVisible(e);
  };

  const getMainClassNames = () => {
    const clazzName = isListCard
      ? `${position}-item__main`
      : classNames(`${position}-grid-item__main`, {
          [`${position}-grid-item__open`]: isItemOpen,
        });

    return classNames(clazzName, {
      "inactive-background": inactive,
    });
  };

  const toggleFavourite = (e) => {
    e.stopPropagation();
    if (ownerlessShop) return onFavouriteAddRemove();
    const currentState = isFavourite ? "remove" : "add";
    const url = `${location.origin}/api/subscriptions/${subscriptionId}/listing/${id}/favourize/`;
    post(url)
      .then(() => {
        onFavouriteAddRemove(id, currentState, categoryId, name);
      })
      .catch((err) => console.log(err));
  };

  return (
    <Template
      {...props}
      inactive={inactive}
      showQuantityControl={showQuantityControl}
      gridStyle={gridStyle}
      soldOutText={soldOutText}
      isEditableContainer={isEditableContainer}
      isFavourite={isFavourite}
      extraPriceInfo={extraPriceInfo}
      price={price}
      getItemClasses={getItemClasses}
      handleMainContentClick={handleMainContentClick}
      getMainClassNames={getMainClassNames}
      toggleFavourite={toggleFavourite}
    />
  );
}
